import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  "xml:space": "preserve"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.59 10.21h-2.38l.62-3.12 4.78-1.98-.39-1.05-5.31 2.21-.79 3.94H9.09a.47.47 0 0 0-.36.18c-.09.11-.13.25-.11.41l1.95 14.83c.04.25.24.43.47.43h6.54c.24 0 .43-.18.47-.43l2.01-14.85c.02-.14-.02-.3-.11-.41-.08-.12-.21-.16-.36-.16zm-9.55 4.1-.41-3.1h6.28l-.62 3.1h-5.25zm2.74 1.8.96 1.02-.96 1.02-.96-1.02.96-1.02zm-.07 7.54-.62-1.3 1.22-.66.62 1.3-1.22.66zm3.35-3.28-1.31-.43.41-1.39 1.31.43-.41 1.39zm2.57-6.06h-2.25l.62-3.1h2.04l-.41 3.1z"
    }, null, -1)
  ])))
}
export default { render };